import { render, staticRenderFns } from "./PsConfiguration.vue?vue&type=template&id=f064325c&scoped=true&"
import script from "./PsConfiguration.vue?vue&type=script&lang=js&"
export * from "./PsConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f064325c",
  null
  
)

export default component.exports